var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Vue, Component } from "vue-facing-decorator";
import { State, Action } from "vuex-facing-decorator";
// Store
import { LoginState } from "@/app/store/modules/login.state";
import { AppConfigState } from "@/app/store/modules/appconfig.state";
// Components
import TopMenuVue from "@/app/vues/navigation/top-menu.vue";
import LeftMenuVue from "@/app/vues/navigation/left-menu.vue";
import LicenseWarningBanner from "@/app/vues/components/license-warning-banner.vue";
import { TextHelper } from "@/app/utils/text-helper";
import ConfirmVue from "@/app/vues/components/confirm.vue";
import { CompaniesClient } from "@/app/api/battery-portal-api";
const companiesClient = new CompaniesClient(window.apiUrl);
let App = class App extends Vue {
    created() {
        if (!window.appConfig)
            return;
        this.configure(window.appConfig);
    }
    ;
    mounted() {
        // this will ensure we display appropriate page titles when the page is "hard" re-loaded
        let pageTitle = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : "";
        document.title = TextHelper.getPageTitle(pageTitle, this.appConfigState.appTitle, this.appConfigState.applicationReleaseDesignation);
        this.checkCompanyPaymentStatus();
    }
    ;
    checkCompanyPaymentStatus() {
        if (this.loginState.authenticated && !this.loginState.isPowerShield) {
            var companyPaymentState = companiesClient
                .getCompanyPaymentStatus()
                .then((paymentStatus) => {
                if (!(paymentStatus === null || paymentStatus === void 0 ? void 0 : paymentStatus.message))
                    return;
                this.$notify({
                    group: "payment-status",
                    title: paymentStatus.title,
                    text: paymentStatus.message,
                });
            });
        }
    }
    componentKey(route) {
        let paramArray = new Array();
        if (route.params) {
            Object.keys(route.params).forEach((key, idx) => {
                let prop = route.params[key] || "";
                paramArray.push(`${prop}`);
            });
        }
        let key = `${route.name}${paramArray.join("_")}`;
        return key;
    }
    ;
    get bodyClass() {
        return `${this.renderLayout ? "dark" : "gray"} clearfix`;
    }
    ;
    get rightPanelClass() {
        return this.renderLayout ? "right_col" : "clearfix";
    }
    ;
    get renderLayout() {
        return this.$route.path != "/login" && this.$route.path != "/logout" && this.loginState.authenticated;
    }
    get cachedVues() {
        var vues = [
            "HomeVue",
            "TrendVue",
            "StringSnapshotVue",
            "DischargeVue"
        ];
        return vues.join(",");
    }
    ;
};
__decorate([
    State("appConfigModule"),
    __metadata("design:type", typeof (_a = typeof AppConfigState !== "undefined" && AppConfigState) === "function" ? _a : Object)
], App.prototype, "appConfigState", void 0);
__decorate([
    State("loginModule"),
    __metadata("design:type", typeof (_b = typeof LoginState !== "undefined" && LoginState) === "function" ? _b : Object)
], App.prototype, "loginState", void 0);
__decorate([
    Action("configure", { namespace: "appConfigModule" }),
    __metadata("design:type", Object)
], App.prototype, "configure", void 0);
App = __decorate([
    Component({
        name: "App",
        components: {
            TopMenuVue,
            LeftMenuVue,
            LicenseWarningBanner,
            ConfirmVue,
        }
    })
], App);
export default App;
